var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    _c("div", { staticClass: "page-titles p-3 border-bottom" }, [
      _c("h3", { staticClass: "text-themecolor" }, [
        _vm._v("General Partner\n            "),
        _vm.user.profile
          ? _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(
                _vm._s(
                  _vm.user.profile.first_name + " " + _vm.user.profile.last_name
                ) +
                  " (" +
                  _vm._s(_vm.user.email) +
                  ")"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm pull-right",
            on: {
              click: function ($event) {
                return _vm.$router.push("/account/users/general-partners")
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-sm-inline" }, [
              _vm._v("General Partners"),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0 pta-gp-weightings",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-12 col-sm-8" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body p-4" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("user-sidebar", {
                        attrs: { menu: "login-log", id: _vm.id },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-9 col-sm-9" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v("Login Log"),
                        ]),
                        _vm._v(" "),
                        _vm.login_logs.length
                          ? _c("div", { staticClass: "table-responsive" }, [
                              _c(
                                "table",
                                { staticClass: "table table-hover" },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.login_logs,
                                      function (login_log) {
                                        return _c("tr", [
                                          login_log.created_at
                                            ? _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("momentTime")(
                                                      login_log.created_at
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _c("td", [_vm._v("-")]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _c("div", [_vm._v("No entries found.")]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("user-summary", { attrs: { user: _vm.user } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [_c("th", { attrs: { scope: "col" } }, [_vm._v("Date")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }